// extracted by mini-css-extract-plugin
export default {"container":"general_container__xWtJF"};